import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { ParticipantDataTabButtons } from './components/ParticipantDataTabButtons';
import { ParticipantDataTablesTab } from './components/ParticipantDataTablesTab';
import { ParticipantDataWidgetsTab } from './components/ParticipantDataWidgetsTab';

interface Props {
  participantId: string;
  isDisabled?: boolean;
}

export const ParticipantData = (props: Props) => {
  const { participantId, isDisabled } = props;

  const [tabValue, setTabValue] = React.useState<string>('widgets');

  return (
    <ChakraV3.Tabs.Root
      defaultValue={tabValue}
      onValueChange={({ value }) => setTabValue(value)}
      variant='subtle'
      size='sm'
      h='full'
      overflowY='hidden'
      lazyMount
    >
      <ChakraV3.Tabs.ContentGroup overflowY='auto' h='full' w='full' border='none' m={0} p={0}>
        <ChakraV3.Tabs.Content value='widgets' p={0} h='full'>
          <ParticipantDataWidgetsTab
            participantId={participantId}
            tabButtons={<ParticipantDataTabButtons value={tabValue} onChange={setTabValue} />}
            isDisabled={isDisabled}
          />
        </ChakraV3.Tabs.Content>
        <ChakraV3.Tabs.Content value='tables' p={0} h='full'>
          <ParticipantDataTablesTab
            participantId={participantId}
            tabButtons={<ParticipantDataTabButtons value={tabValue} onChange={setTabValue} />}
            isDisabled={isDisabled}
          />
        </ChakraV3.Tabs.Content>
      </ChakraV3.Tabs.ContentGroup>
    </ChakraV3.Tabs.Root>
  );
};
